
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { CustomSolutionsForm } from './CustomSolutionsForm';
import { CustomSolutionsFormValues } from './formSchema';

interface CustomSolutionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CustomSolutionsDialog = ({ open, onOpenChange }: CustomSolutionsDialogProps) => {
  const { toast } = useToast();

  const handleWebhookSubmit = async (formData: CustomSolutionsFormValues) => {
    try {
      const webhookUrl = import.meta.env.VITE_CUSTOM_SOLUTIONS_WEBHOOK_URL;
      
      if (!webhookUrl) {
        throw new Error("Custom solutions webhook URL not configured - please set VITE_CUSTOM_SOLUTIONS_WEBHOOK_URL in your environment variables");
      }
      
      await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "no-cors",
        body: JSON.stringify({
          ...formData,
          source: "Custom Solutions Form",
          timestamp: new Date().toISOString(),
          page: window.location.href
        }),
      });

      onOpenChange(false);
    } catch (error) {
      console.error("Error triggering webhook:", error);
      toast({
        title: "Submission failed",
        description: "There was an issue processing your request. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Book Your Custom Solutions Call</DialogTitle>
          <DialogDescription>
            Tell us about your firm's needs and what you're hoping to achieve with custom AI solutions.
          </DialogDescription>
        </DialogHeader>
        <CustomSolutionsForm 
          onSubmit={handleWebhookSubmit} 
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CustomSolutionsDialog;
